/** 根据断点选择桌面/移动 SVG，并把菜单节点点击转换为内部滚动容器的位置。 */
import { memo, useCallback, useLayoutEffect, useState } from 'react';
import { data } from '../../../data';
import ProgressPathDesktop from './ProgressPathDesktop';
import ProgressPathMobile from './ProgressPathMobile';

type Props = {
    onButtonClick?: () => void;
};

// 相机数据有多少段，Drei ScrollControls 就有多少逻辑页面。
const totalScreens = Object.keys(data).length;

const ProgressPath = ({ onButtonClick }: Props) => {
    const [isMobile, setIsMobile] = useState(false);

    // layout effect 在浏览器绘制前决定 SVG 版本，减少桌面/移动图形闪烁。
    useLayoutEffect(() => {
        const onResize = () => {
            setIsMobile(matchMedia('(max-width: 767px)').matches);
        };

        onResize();
        window.addEventListener('resize', onResize);

        return () => window.removeEventListener('resize', onResize);
    }, []);

    const onClick = useCallback(
        (travelToScreen: number) => {
            // 下一帧操作 Drei 创建的真实滚动元素；+1 避免卡在章节边界的浮点误差。
            requestAnimationFrame(() => {
                (window as any)._scrollEl.scrollTop =
                    1 +
                    ((window as any)._scrollEl.scrollHeight / totalScreens) *
                        (travelToScreen - 1);

                // 滚动位置写入完成后通知 Menu 关闭自己。
                onButtonClick?.();
            });
        },
        [onButtonClick],
    );

    return (
        <div className="progress-path-svg-wrapper">
            {isMobile ? (
                <ProgressPathMobile onButtonClick={onClick} />
            ) : (
                <ProgressPathDesktop onButtonClick={onClick} />
            )}
        </div>
    );
};

export default memo(ProgressPath);
